<template>
  <div class="admin-shell">
    <!-- Sidebar -->
    <aside class="sidebar">
      <nav class="nav">
        <RouterLink to="/admin/overview" class="nav-item" active-class="is-active">
          <i class="fa-solid fa-gauge" />
          <span>{{ $t('components.adminDashboard.overview') }}</span>
        </RouterLink>
        <RouterLink to="/admin/domains" class="nav-item" active-class="is-active">
          <i class="fa-solid fa-globe" />
          <span>{{ $t('components.adminDashboard.allDomains') }}</span>
        </RouterLink>
        <RouterLink to="/admin/users" class="nav-item" active-class="is-active">
          <i class="fa-solid fa-users" />
          <span>{{ $t('components.adminDashboard.allUsers') }}</span>
        </RouterLink>
      </nav>
    </aside>

    <!-- Main -->
    <main class="content page-container">
      <router-view />
    </main>
  </div>
</template>

<script setup lang="ts">
import { useUserStore } from '@/stores/userStore';
import { Role } from '@/types/enum/user';
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';

  const router = useRouter()
  const userStore = useUserStore();
  
  onMounted(() => {
    const isLoggedIn = !!userStore.user?.pk
    if (!isLoggedIn) {
      router.push('/login')
    }
    const allowedUsers = ['m.wakolbinger@wako3d.com']
    const isAllowed = allowedUsers.includes(userStore.user?.email ?? '')
    if(!isAllowed)
      router.push('/login')
  })

</script>

<style scoped lang="scss">
@use '@/assets/styles/variables' as *;

.admin-shell {
  display: flex;
  min-height: 100vh;
  background: var(--color-page-bg, #f6f6f6);
}

/* ─ Sidebar ─ */
.sidebar {
  min-width: 220px;
  flex-shrink: 0;
  background: var(--color-surface, #ffffff);
  border-right: 1px solid var(--el-border-color-lighter, #e4e4e4);
  padding: 1rem;
  overflow: hidden;
}

.nav {
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
}

.nav-item {
  display: flex;
  align-items: center;
  gap: 0.9rem;
  width: 100%;
  padding: 0.9rem 1.1rem;
  background: var(--color-surface, #ffffff);
  border: 1px solid var(--el-border-color-lighter, #e4e4e4);
  border-radius: var(--corner-radius, 10px);
  box-shadow: 0 1px 2px rgba(0,0,0,0.04);
  font-size: 0.96rem;
  font-weight: 600;
  color: var(--el-text-color-regular, #4f4f4f);
  text-decoration: none;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;

  i {
    font-size: 1.15rem;
    width: 1.4rem;
    text-align: center;
  }

  &:hover {
    background: var(--el-fill-color-light, #f5f7fa);
    border-color: var(--el-border-color, #dcdfe6);
  }
}

.is-active {
  border-color: var(--el-color-primary);
  color: var(--el-color-primary);
  border-left-width: 4px;
  padding-left: calc(1.1rem - 4px);
}

/* ─ Content ─ */
.content {
  flex: 1;
  overflow-x: hidden;
  margin-left: 12rem;
}
</style>
